import { Stack, Typography, Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { OldCardState, oldCardStates } from "./enums/OldCardState";
import { CardSwapSearchOldCardDto } from "./dtos/CardSwapSearchOldCardDto";
import { CardSwapUpdateDto } from "./dtos/CardSwapUpdateDto";
import { CardSwapStatusCode, cardSwapStatusCodes } from "./enums/CardSwapStatusCode";
import { useContext, useEffect, useState } from "react";
import VspPortalContext from "../../store/VspPortalContext";
import { CardSwapSearchResultDto } from "./dtos/CardSwapSearchResultDto";
import { useCardSwapHttp } from "./hooks/useCardSwapHttp";
import { formatDateTime } from "../../utils";


type OldCardToggleProps = {

    isUpdating : boolean;
    cardSwapSearchResultDto:  CardSwapSearchResultDto;
    oldCardDto : CardSwapSearchOldCardDto;
    setDialogHeader( dialogHeader : string ) : void;
    setIsUpdated( isUpdated : boolean ) : void ;
    setIsUpdating( isUpdating : boolean ) : void ;

};


export const OldCardToggle: React.FC< OldCardToggleProps > = ( props : OldCardToggleProps ) => {

    const { isUpdating, cardSwapSearchResultDto, oldCardDto, setDialogHeader, setIsUpdated, setIsUpdating } = props;

    const [ oldCard, setOldCard ] = useState< CardSwapSearchOldCardDto >( oldCardDto );
    const [ oldCardCurrentStates, setOldCardCurrentStates ] = useState< { [ key: string ]: OldCardState } >( { } );

    const { state } = useContext( VspPortalContext );

    const { updateCardSwap } = useCardSwapHttp( );


    useEffect( ( ) => {


        const oldCardsStates: { [ key: string ]: OldCardState } = { };

        for( const oldCard of cardSwapSearchResultDto.oldCards ){

            if( !oldCard.deactivatedDateTime && !oldCard.returnedDateTime ){

                oldCardsStates[ oldCard.cardNumber ] = OldCardState.NotReturned;

            } else if( oldCard.deactivatedDateTime ){

                oldCardsStates[ oldCard.cardNumber ] =  OldCardState.Deactivated;
            
            } else if( oldCard.returnedDateTime ){

                oldCardsStates[ oldCard.cardNumber ] =  OldCardState.Returned;

            }

        }
        
        setOldCardCurrentStates( oldCardsStates );

    }, [ ]);


    const deactivateCard = async( cardNumber : string ) => {

        const deactivatedCards = Object.fromEntries( Object.entries( oldCardCurrentStates ).filter( ( [ _, v ] ) => v == OldCardState.Deactivated ) );
        const allCardsDeactivated = Object.keys( deactivatedCards ).length + 1 === Object.keys( oldCardCurrentStates).length;

        let cardSwapUpdateDto : CardSwapUpdateDto = {

            deactivatedCardNumbers : [ cardNumber ],
            id : cardSwapSearchResultDto.id,
            updatedBy : state.username

        };


        if( allCardsDeactivated ){

            cardSwapUpdateDto  = {

                cardSwapStatusCode : CardSwapStatusCode.OldCardsDeactivated,
                deactivatedCardNumbers : [ cardNumber ],
                id : cardSwapSearchResultDto.id,
                updatedBy : state.username
    
            };

        }

        setIsUpdating( true );
        const isSuccess = await updateCardSwap( cardSwapUpdateDto );
        setIsUpdating( false );

        if( isSuccess ){

            setIsUpdated( true );

            const updatedOldCard = { ...oldCard, deactivatedDateTime : new Date( ).toUTCString( ) };
            setOldCard( updatedOldCard );

            if( allCardsDeactivated ){

                setDialogHeader( cardSwapStatusCodes[ CardSwapStatusCode.OldCardsDeactivated ]);

            }

        }

    };
    

    const handleOldCardStateChange = ( cardNumber : string, oldCardState : OldCardState ) => {

        if( !oldCardState ){

            return;

        }

        const oldCardsStates = { ...oldCardCurrentStates };
        
        if( oldCardState === OldCardState.Returned ){

            returnCard( cardNumber );
            oldCardsStates[ cardNumber ] = OldCardState.Returned;

        }

        if( oldCardState === OldCardState.Deactivated ){
        
            deactivateCard( cardNumber );
            oldCardsStates[ cardNumber ] = OldCardState.Deactivated;
        
        }
        
        setOldCardCurrentStates( oldCardsStates );

    };


    const returnCard = async( cardNumber : string ) => {

        const returnedCards = Object.fromEntries( Object.entries( oldCardCurrentStates ).filter( ( [ _, v ] ) => v == OldCardState.Returned ) );
        const allCardsReturned = Object.keys( returnedCards ).length + 1 === Object.keys( oldCardCurrentStates).length;

        let cardSwapUpdateDto : CardSwapUpdateDto = {

            returnedCardNumbers : [ cardNumber ],
            id : cardSwapSearchResultDto.id,
            updatedBy : state.username

        };
        
        if( allCardsReturned ){

            cardSwapUpdateDto  = {

                cardSwapStatusCode : CardSwapStatusCode.DeactivatingOldCards,
                returnedCardNumbers : [ cardNumber ],
                id : cardSwapSearchResultDto.id,
                updatedBy : state.username
    
            };

        }

        setIsUpdating( true );
        const isSuccess = await updateCardSwap( cardSwapUpdateDto );
        setIsUpdating( false );

        if( isSuccess ){

            setIsUpdated( true ); 

            const updatedOldCard = { ...oldCard, returnedDateTime: new Date().toUTCString() };
            setOldCard( updatedOldCard );

            if( allCardsReturned ){

                setDialogHeader( cardSwapStatusCodes[ CardSwapStatusCode.DeactivatingOldCards ]);

            }

        }

    };

    return(

        <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 } key={ oldCard.cardNumber }>
                    
            <Typography sx={{ lineHeight: '45px' }}>
                { oldCard.cardNumber }
            </Typography>

            <Box sx={{ flexGrow: 1 }} />

            <Stack direction="column">

                <ToggleButtonGroup
                    color="primary"
                    disabled={ isUpdating }
                    value={ oldCardCurrentStates[ oldCard.cardNumber ] }
                    exclusive
                    onChange={ ( _: React.MouseEvent<HTMLElement>, oldCardState: OldCardState ) => handleOldCardStateChange( oldCard.cardNumber, oldCardState ) }
                    sx={{ marginBottom : '5px'}}
                >
                    <ToggleButton disabled={ oldCardCurrentStates[ oldCard.cardNumber ] === OldCardState.Returned || oldCardCurrentStates[ oldCard.cardNumber ] === OldCardState.Deactivated } value={ OldCardState.NotReturned } sx={{ textTransform: 'none' }}>{ oldCardStates[ OldCardState.NotReturned ] }</ToggleButton>
                    <ToggleButton disabled={ oldCardCurrentStates[ oldCard.cardNumber ] === OldCardState.Deactivated } value={ OldCardState.Returned } sx={{ textTransform: 'none' }}>{ oldCardStates[ OldCardState.Returned ] }</ToggleButton>
                    <ToggleButton disabled={ oldCardCurrentStates[ oldCard.cardNumber ] === OldCardState.NotReturned } value={ OldCardState.Deactivated } sx={{ textTransform: 'none' }}>{ oldCardStates[ OldCardState.Deactivated ] }</ToggleButton>

                </ToggleButtonGroup>

                { 

                    oldCard.returnedDateTime 
                        && 
                    <Typography sx={{ fontSize: 12 }}>
                        Returned: { formatDateTime( new Date( oldCard.returnedDateTime ) )  }
                    </Typography>

                }

                { 

                    oldCard.deactivatedDateTime 
                        && 
                    <Typography sx={{ fontSize: 12 }}>
                        Deactivated: { formatDateTime( new Date( oldCard.deactivatedDateTime ) )  }
                    </Typography>

                }

            </Stack>

        </Stack>

    );

};